import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'modal',
  initialState: {
    isLoading: false, // show or hide global loading
    showSetting: false, // show or hide setting menu (gear icon on top right side)
    showFilter: false, // show or hide filter data popup
    productDetail: false, // show or hide product detail
    userForm: false, // show or hide user form
    userCreateOption: false, // show or hide create option for user setting
    marketCreateOption: false,
    exportLoyalty: false,
    editLoyalty: false,
    changeCountry: false,
    changeLanguage: false,
    changePhoneNumber: false,
    changePassword: false,
    marketTypeForm: false, // show or hide market type & business type form
    sociollaFilter: false,
    pricelistUpload: false,
    productPriceRules: false,
    productPriceRulesList: false,
    CMSCreateOption: false,
    visitDetail: false,
    visitTeamDetail: false,
    showPastExport: false,
    showGWPTracker: false,
    editBudget: false,
    showCustomerExportFilter: false,
    showBulkDeleteActivity: false,
    listCustomerAndBrandOptions: false,
    showAddManual: false,
    showCatalogExport: false,
    showCatalogExportMenu: false,
    showBrandExportMenu: false,
    exportActivityOption: false,
    exportCustomerOption: false,
    exportCalenderActivity: false,
    exportInvoiceCollection: false,
    exportAllCustomer: false,
    showImportModalSO: false,
    showImportModalCustomer: false,
    showImportModalSkp: false,
    showImportModalSalesActivity: false,
    showPromotionRuleExport: false,
    showImportModalPricelist: false,
    showImportModalUser: false,
    showImportModalMtBtProduct: false,
    showImportModalAccountProduct: false,
    showImportModalTargetSetting: false,
    showImportModalRequestProductListing: false,
    showImportModalAddProductListing: false,
    showImportModalForecastStock: false,
    showImportModalAddProductPriceList: false,
    showImportModalPromotionAccounts: false,
    promotionAccountCreateOption: false,
  },
  reducers: {
    showPopup: (state, action) => {
      state[action.payload.name] = action.payload.value;
    },
  },
});

export const { showPopup } = slice.actions;
export default slice.reducer;
